import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export const playImg = "/play.svg"
export const pauseImg = "/pause.svg"
export const replayImg = "/replay.svg"

export const performanceBlack = "/performance-black.mp4"
export const performanceWhite = "/performance-white.mp4"
export const optimizationBlack = "/rendering-black.mp4"
export const optimizationWhite = "/rendering-white.mp4"
export const securityBlack = "/security-black.mp4"
export const securityWhite = "/security-white.mp4"
export const scalabilityBlack = "/scalability-black.mp4"
export const scalabilityWhite = "/scalability-white.mp4"

export const firstCardCarouselWhite = "/first-card-carousel-white.png"
export const firstCardCarouselBlack = "/first-card-carousel-black.png"
export const secondCardCarouselWhite = "/second-card-carousel-white.png"
export const secondCardCarouselBlack = "/second-card-carousel-black.png"
export const thirdCardCarouselWhite = "/third-card-carousel-white.png"
export const thirdCardCarouselBlack = "/third-card-carousel-black.png"
export const fourthCardCarouselWhite = "/fourth-card-carousel-white.png"
export const fourthCardCarouselBlack = "/fourth-card-carousel-black.png"
export const fifthCardCarouselWhite = "/fifth-card-carousel-white.png"
export const fifthCardCarouselBlack = "/fifth-card-carousel-black.png"
export const sixthCardCarouselWhite = "/sixth-card-carousel-white.png"
export const sixthCardCarouselBlack = "/sixth-card-carousel-black.png"

// AI Chat Integration Video

export const aiVideoBlack = "/video-minimalist-dark.mp4"
export const aiVideoWhite = "/video-minimalist-white.mp4"
